import { useEffect } from "react";
import { _ROUTES } from "../../../utils/_routes_constants";
import { convertBackendDataToRows } from "../../../utils/AgGridUtils/convertBackendDataToRows";
import { DataTable } from "../../ui/DataTable";
import { buildIRI } from "../../../utils/function";
import { useBudgetData } from "../../../hooks/useBudgetData";

export const TableIt = ({
  rows,
  setRows,
  params,
  isDataLoading,
  onDataLoadingStart,
  onDataLoadingStop,
  gridRef,
}) => {
  const { loadData, handleCellValueChanged } = useBudgetData({
    setRows,
    onDataLoadingStart,
    onDataLoadingStop,
    params,
    formDataToRow: (groupedData) =>
      convertBackendDataToRows(groupedData, {
        groupKey: "theme",
      }),
  });

  useEffect(() => {
    loadData(_ROUTES.IPT_ITS_GROUP);
  }, [params.activity]);

  const generateItPayload = ({ colDef, data, newValue }) => {
    const field = colDef.field;
    const month = parseInt(field.replace("months.", ""));

    const payload = {
      amount: newValue,
      theme: data.theme,
      site: buildIRI("/sites", data.siteId),
      fiscalMonth: month,
      fiscalYear: params.fiscalYear,
      version: params.version || 1,
    };

    if (data.fiscal_month_id_mapping && data.fiscal_month_id_mapping[month]) {
      payload.id = data.fiscal_month_id_mapping[month];
    }

    return payload;
  };

  const handleCellChange = (agParams) => {
    handleCellValueChanged(agParams, generateItPayload, _ROUTES.IPT_ITS);
  };

  return (
    <DataTable
      isDataLoading={isDataLoading}
      rows={rows}
      columnsIncludeMonths={true}
      gridRef={gridRef}
      columns={[
        {
          headerName: "",
          field: "theme",
          hide: true,
          rowGroup: true,
          suppressHeaderMenuButton: true,
        },
        {
          headerName: "",
          field: "site",
          showRowGroup: "theme",
          minWidth: 200,
          suppressHeaderMenuButton: true,
        },
      ]}
      onCellValueChanged={handleCellChange}
      agGridProps={{
        groupDisplayType: "groupRows",
        getRowStyle: (params) => {
          if (params.data === undefined) {
            return { backgroundColor: "#D3D3D3" };
          }
        },
      }}
    />
  );
};
